import { EditorState, Modifier } from 'draft-js';
import Immutable from 'immutable';
import converters from './converters';
import getCharacter from '../../utilities/characterUtilities';
import { BLOCK_TYPE } from '../../utilities/CONSTANTS';
import { getCurrentBlockTextUntilCursor, insertHrBlock } from '../../utilities/blockUtilities';

class AutoMarkdown {
    static keyBindingFn(e, editorState) {
        const character = getCharacter(e.keyCode, e.shiftKey);
        const text = getCurrentBlockTextUntilCursor(editorState);
        for (let i = 0; i < converters.length; i += 1) {
            if (converters[i].regex.test(text + character)) {
                return converters[i].command;
            }
        }
        return false;
    }

    static handleKeyCommand(editorState, command) {
        for (let i = 0; i < converters.length; i += 1) {
            if (command === converters[i].command) {
                return AutoMarkdown.handleCommand(editorState, converters[i].blockType);
            }
        }
        return false;
    }

    static handleCommand(editorState, blockType) {
        let modifiableEditorState = editorState;

        const selection = modifiableEditorState.getSelection();
        const blockKey = selection.getStartKey();

        let contentState = modifiableEditorState.getCurrentContent();

        modifiableEditorState = EditorState.push(
            modifiableEditorState,
            Modifier.insertText(
                contentState,
                selection,
                ' ',
            ),
            'insert-characters',
        );

        const blockSelection = selection.merge({
            anchorKey: blockKey,
            anchorOffset: 0,
        });

        contentState = Modifier.replaceText(contentState, blockSelection, '');

        if (blockType === BLOCK_TYPE.HR) {
            modifiableEditorState = insertHrBlock(modifiableEditorState, contentState);
        } else {
            contentState = Modifier.setBlockType(contentState, contentState.getSelectionAfter(), blockType);
            modifiableEditorState = EditorState.push(modifiableEditorState, contentState);
        }

        modifiableEditorState = EditorState.setInlineStyleOverride(modifiableEditorState, Immutable.OrderedSet());

        return modifiableEditorState;
    }
}

export default AutoMarkdown;
